import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';

import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { UtilitiesService } from '../../../../services/utilities/utilities.service';
import { Router } from '@angular/router';
import {
  handleFileUploaded,
  handleFileUploadError,
} from 'src/app/shared/components/upload-input/file-upload-helper';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-create-admin',
  standalone: false,
  templateUrl: './create-admin.component.html',
  styleUrl: './create-admin.component.scss'
})
export class CreateAdminComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private dialog: MatDialog,
    private utilitiesService: UtilitiesService,
    private router: Router,
    private location: Location
  ) { }

  isSubmitting: boolean;
  isVerifyingAsin: boolean;

  showErrorMessages: boolean = false;

  form: FormGroup;

  lgaList: any;
  zoneList: any;

  roles: any[];


  ngOnInit(): void {
   
    this.loadLgaList()

    this.getRoles()
    this.initializeForm();
  }


  get lgaControl() {
    return this.form.get('lga') as FormControl
  }

  get zoneControl() {
    return this.form.get('zone') as FormControl
  }


  initializeForm() {
    this.form = this.formBuilder.group({
      // asin: ['', [Validators.required, Validators.maxLength(20)]],
      // businessName: ['', [Validators.required]],
      // operationLga: [null, [Validators.required]],
      // meansOfId: [null, [Validators.required]],
      // idNumber: ['', [Validators.required, Validators.maxLength(60)]],
      // idUpload: [null, [Validators.required]],
      role: [null, [Validators.required]],
      lastName: ['', [Validators.required, Validators.maxLength(60)]],
      firstName: ['', [Validators.required, Validators.maxLength(60)]],
      middleName: ['', [Validators.maxLength(60)]],
      phoneNumber: [
        '',
        [Validators.required, this.phoneNumberValidator() as ValidatorFn],
      ],
      email: [
        '',
        [Validators.required, Validators.maxLength(60), this.emailValidator()],
      ],
      address: ['', [Validators.required, Validators.maxLength(120)]],
      lga: [null, [Validators.required]],
      zone: [null, [Validators.required]],
    });

    this.form.get('asin')?.valueChanges.subscribe(() => {
      this.form.get('businessName')?.setValue(''); // Clear businessName
    });

    this.subscribeToLgaChanges()
  }


  loadLgaList() {
    this.utilitiesService.getLocalGovernmentList().subscribe(
      (response) => {
        this.lgaList = response;
      },
      (error) => {
        this.openErrorModal('Error Fetching Local Government');
      }
    );
  }

  subscribeToLgaChanges() {
    this.lgaControl.valueChanges.subscribe(lga => {
      this.zoneList = null;
      this.zoneControl.reset()
      this.getZonesFromLga(lga);
    })
  }

  getZonesFromLga(lga) {
    this.utilitiesService.getZonesFromLga(lga).subscribe((res: any) => {
      this.zoneList = res;
    });
  }



  goBack() {
    this.location.back();
  }



  getRoles() {
    this.apiService
      .get('/roles/all', {})
      .subscribe(
        (response) => {

          this.roles = response.data.filter((role: any) => !['SUPER_AGENT', 'SUB_AGENT', 'GENERAL_USER'].includes(role.name));

        },
        (error) => {

          this.openErrorModal(error?.message)

        }
      );
  }

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value === null || control.value === undefined) {
        return null;
      }

      const cleanedPhoneNumber = control.value
        .replace(/\s/g, '')
        .replace(/-/g, '');

      const isDigitsOnly = /^\d+$/.test(cleanedPhoneNumber);

      if (
        cleanedPhoneNumber.length === 0 ||
        (cleanedPhoneNumber.length === 11 && isDigitsOnly) ||
        (cleanedPhoneNumber.length === 13 &&
          cleanedPhoneNumber.startsWith('234')) ||
        (cleanedPhoneNumber.length === 14 &&
          cleanedPhoneNumber.startsWith('+234'))
      ) {
        return null;
      } else {
        return { invalidPhoneNumber: true };
      }
    };
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (control.value && !emailPattern.test(control.value)) {
        return { invalidEmail: true };
      }

      return null;
    };
  }

  onFileChange(
    fileDetails: { file: File; readableUrl: string } | null,
    controlName: string
  ) {
    handleFileUploaded(fileDetails, this.form, controlName);
  }

  onError(errorResponse: any, controlName: string) {
    handleFileUploadError(errorResponse, this.form, controlName);
  }

  verifyAsin() {
    const asin = this.form.get('asin')?.value;

    this.isVerifyingAsin = true;

    this.apiService
      .get('/utility/asin/validate?tin=' + asin)
      .pipe(
        finalize(() => {
          this.isVerifyingAsin = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.form.patchValue({
            businessName: response?.firstName,
          });

          this.openAsinVerificationSuccessModal('ASIN verified successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.initializeForm();

      this.router.navigate(['/admin/admin-management']);
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'operation-modal', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Create Admin?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.createAdmin();
        },
        onCancel: () => { },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  async createAdmin(): Promise<void> {
    if (this.form.valid) {
      this.isSubmitting = true;

      try {
        const formData = this.form.value;
        const request = await this.mapFormValuesToObject(formData);

        const url = '/auth/admin/create';

        this.apiService
          .post(url, request)
          .pipe(finalize(() => (this.isSubmitting = false)))
          .subscribe(
            () => {
              this.openSuccessModal('Admin created successfully');
            },
            (error) => {
              this.openErrorModal(error?.message);
            }
          );
      } catch (error) {
        this.isSubmitting = false;
        this.openErrorModal('Failed to process form data');
      }
    }
  }



  async mapFormValuesToObject(formValue: any): Promise<any> {
    let idImageBase64 = '';

    if (formValue.idUpload?.file) {
      const fullBase64 = await this.convertFileToBase64(
        formValue.idUpload.file
      );
      idImageBase64 = fullBase64.split(',')[1];
    }

    return {
      name: `${formValue.firstName.trim()} ${formValue.middleName.trim() ?? ''} ${formValue.lastName.trim()}`.trim(),
      email: formValue.email,
      password: formValue.phoneNumber,
      role: formValue.role,
      lga: formValue.lga,
      zone: formValue.zone,
      operationLga: formValue.operationLga,
      phoneNumber: formValue.phoneNumber,
      address: formValue.address,
      taxGroup: 'ADMIN',
      businessName: formValue.businessName,
      asin: formValue.asin,
      idType: formValue.meansOfId,
      idNumber: formValue.idNumber,
      idImage: idImageBase64,
    };
  }

  openAsinVerificationSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }
}
